import styled, { css } from 'styled-components'

import {
  LANDING_COLUMN_GAP,
  LANDING_SPACING,
  SCROLL_FADE_HEIGHT,
  SCROLLBAR_LANE,
  SCROLLBAR_WIDTH,
} from './landingScrollConstants'

export const verticalScrollbarStyles = css`
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: ${SCROLLBAR_WIDTH};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 9999rem;
    background: ${({ theme }) => theme.forecast.border};
  }
`

const edgeFadeConfig = {
  below: {
    direction: 'to bottom',
    position: css`
      left: 0;
      right: 0;
      bottom: calc(-1 * ${SCROLL_FADE_HEIGHT});
      height: ${SCROLL_FADE_HEIGHT};
    `,
  },
  bottom: {
    direction: 'to top',
    position: css`
      left: 0;
      right: 0;
      bottom: 0;
      height: ${SCROLL_FADE_HEIGHT};
    `,
  },
} as const

export type EdgeFadePlacement = keyof typeof edgeFadeConfig

export const EdgeFade = styled.div<{ $placement: EdgeFadePlacement }>`
  position: absolute;
  pointer-events: none;
  z-index: 1;
  ${({ $placement }) => edgeFadeConfig[$placement].position}
  background: linear-gradient(
    ${({ $placement }) => edgeFadeConfig[$placement].direction},
    ${({ theme }) => theme.forecast.pageBackground1},
    transparent
  );
`

export const LandingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: ${({ theme }) => theme.forecast.pageBackground1};
  padding: ${LANDING_SPACING} 2rem 0;
  gap: ${LANDING_SPACING};
  height: 100%;
  width: 100%;
  overflow: hidden;
`

export const LogoSection = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const LandingColumnWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  min-height: 0;
  width: 100%;
`

export const LandingColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 56.25rem;
  overflow: visible;
`

export const LandingBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${LANDING_COLUMN_GAP};
  flex: 1;
  min-height: 0;
  width: 100%;
`

export const SearchSection = styled.div`
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.forecast.pageBackground1};
`

export const ScrollRow = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  margin-top: calc(-1 * ${SCROLL_FADE_HEIGHT});
  width: calc(100% + ${SCROLLBAR_LANE});
  z-index: 1;
`

export const ScrollTrack = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  ${verticalScrollbarStyles}
`

export const ScrollContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${LANDING_COLUMN_GAP};
  width: calc(100% - ${SCROLLBAR_LANE});
  min-height: 100%;
  padding-top: ${SCROLL_FADE_HEIGHT};
  padding-bottom: 2rem;
`

export const SectionContainer = styled.div`
  width: 100%;
`

export const SectionLabel = styled.h2`
  font-size: 0.75rem;
  font-weight: 400;
  color: ${({ theme }) => theme.forecast.secondaryText};
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

export const FavoritesGrid = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
`
